import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { graphql } from 'gatsby';
import { Layout, Code, Showcase, ClassTable, Header } from '../../../../components';
import './style.scss';
import data from './data.json';
import changelog from '../../../../data/changelog.json';
export const classes = {
  headings: ['Class', 'Type', 'CSS', 'Description'],
  data: [{
    class: '.u-flex-container',
    type: 'parent',
    css: 'display: flex',
    description: 'Used on any element to declare it as a flex element.'
  }, {
    class: '.u-flex-align--left',
    type: 'parent',
    css: 'justify-content: flex-start',
    description: 'Distributes flex children to the left.'
  }, {
    class: '.u-flex-align--right',
    type: 'parent',
    css: 'justify-content: flex-end',
    description: 'Distributes flex children to the right.'
  }, {
    class: '.u-flex-align--center',
    type: 'parent',
    css: 'justify-content: middle',
    description: 'Distributes flex children to the middle.'
  }, {
    class: '.u-flex-align--justify',
    type: 'parent',
    css: 'justify-content: space-between',
    description: 'Distributes flex children to the left and right edges of the container.'
  }, {
    class: '.u-flex-align--spaced',
    type: 'parent',
    css: 'justify-content: space-around',
    description: 'Distributes flex children evenly all around.'
  }, {
    class: '.u-flex-align--top',
    type: 'parent',
    css: 'align-items: top',
    description: 'Aligns flex children to the top of container.'
  }, {
    class: '.u-flex-align--middle',
    type: 'parent',
    css: 'align-items: center',
    description: 'Aligns flex children to the center of container.'
  }, {
    class: '.u-flex-align--bottom',
    type: 'parent',
    css: 'align-items: bottom',
    description: 'Aligns flex children to the bottom of container.'
  }, {
    class: '.u-flex-align--stretch',
    type: 'parent',
    css: 'align-items: stretch',
    description: 'Stretches flex children to fill the container.'
  }, {
    class: '.u-flex-dir--row',
    type: 'parent',
    css: 'flex-direction: row',
    description: 'All child elements will flow horizonatally from left to right.'
  }, {
    class: '.u-flex-dir--row-reverse',
    type: 'parent',
    css: 'flex-direction: row-reverse',
    description: 'All child elements will flow horizonatally from right to left.'
  }, {
    class: '.u-flex-dir--column',
    type: 'parent',
    css: 'flex-direction: column',
    description: 'All child elements will flow vertically from top to bottom.'
  }, {
    class: '.u-flex-dir--column-reverse',
    type: 'parent',
    css: 'flex-direction: column-reverse',
    description: 'All child elements will flow vertically from bottom to top.'
  }, {
    class: '.u-flex-wrap--wrap',
    type: 'parent',
    css: 'flex-wrap: wrap',
    description: 'All child elements will wrap around to a new row if necessary.'
  }, {
    class: '.u-flex-wrap--nowrap',
    type: 'parent',
    css: 'flex-wrap: nowrap',
    description: 'All child elements will stay on the same row as each other and expand the parent horizontally.'
  }, {
    class: '.u-flex-wrap--wrap-reverse',
    type: 'parent',
    css: 'flex-wrap: wrap-reverse',
    description: 'All child elements will wrap around to a new row, in reverse order, if necessary.'
  }, {
    class: '.u-flex-wrap--wrap-inherit',
    type: 'parent',
    css: 'flex-wrap: inherit',
    description: 'Element will inherit the flex-wrap property from its parent.'
  }, {
    class: '.u-flex-wrap--wrap-initial',
    type: 'parent',
    css: 'flex-wrap: initial',
    description: 'Element will have its default flex-wrap property value.'
  }, {
    class: '.u-flex-wrap--wrap-unset',
    type: 'parent',
    css: 'flex-wrap: unset',
    description: 'Element will inherit the flex-wrap property from its parent if possible, otherwise it will have its default flex-wrap property value.'
  }, {
    class: '.u-flex-align-self--top',
    type: 'child',
    css: 'align-self: start',
    description: 'Aligns self to the top of flex parent container.'
  }, {
    class: '.u-flex-align-self--middle',
    type: 'child',
    css: 'align-self: center',
    description: 'Aligns self to the center of flex parent container.'
  }, {
    class: '.u-flex-align-self--bottom',
    type: 'child',
    css: 'align-self: end',
    description: 'Aligns self to the bottom of flex parent container.'
  }, {
    class: '.u-flex-align-self--stretch',
    type: 'child',
    css: 'align-self: end',
    description: 'Stretches self to fill flex parent container.'
  }, {
    class: '.u-flex-child--auto',
    type: 'child',
    css: 'flex: 1 1 auto',
    description: 'Element will grow and shrink as needed.'
  }, {
    class: '.u-flex-child--grow',
    type: 'child',
    css: 'flex: 1 0 auto',
    description: 'Element will grow to fill the space of flex parent.'
  }, {
    class: '.u-flex-child--shrink',
    type: 'child',
    css: 'flex: 0 1 auto',
    description: 'Element will shrink if necessary to fit inside of parent.'
  }]
};
export const code = {
  flex: `<div class="u-flex-container"></div>
<div class="u-flex-align--left"></div>
<div class="u-flex-align--right"></div>
<div class="u-flex-align--center"></div>
<div class="u-flex-align--center-middle"></div>
<div class="u-flex-align--justify"></div>
<div class="u-flex-align--spaced"></div>
<div class="u-flex-align--top"></div>
<div class="u-flex-align--middle"></div>
<div class="u-flex-align--bottom"></div>
<div class="u-flex-align--stretch"></div>
<div class="u-flex-align-self--top"></div>
<div class="u-flex-align-self--middle"></div>
<div class="u-flex-align-self--bottom"></div>
<div class="u-flex-align-self--stretch"></div>
<div class="u-flex-child--auto"></div>
<div class="u-flex-child--grow"></div>
<div class="u-flex-child--shrink"></div>
<div class="u-flex-dir--row"></div>
<div class="u-flex-dir--row-reverse"></div>
<div class="u-flex-dir--column"></div>
<div class="u-flex-dir--column-reverse"></div>
<div class="u-flex-wrap--wrap"></div>
<div class="u-flex-wrap--nowrap"></div>
<div class="u-flex-wrap--wrap-reverse"></div>
<div class="u-flex-wrap--wrap-inherit"></div>
<div class="u-flex-wrap--wrap-initial"></div>
<div class="u-flex-wrap--wrap-unset"></div>
`
};
export const _frontmatter = {};
const layoutProps = {
  classes,
  code,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title={data.title} site={data.site} state="develop" slug={data.slug + '/develop/'} mdxType="Header" />
    <Layout category={data.category} changelog={changelog[data.title].changelog} description={data.description} site={data.site} slug={data.slug + '/develop/'} state="develop" title={data.title} updated={changelog[data.title].lastUpdated} mdxType="Layout">
      <ClassTable data={classes} mdxType="ClassTable" />
    </Layout>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      